<template>

<main class="py-12">
        <div class="container">
            <article class="dp-article">
                <div class="article-text js-fade-in text-columns-1 is-added is-visible">
                    <h1 class="h1 title">
                        Impressum
                    </h1>
                    <h2>Angaben gemäß § 5 TMG:</h2>
                    <p>
                        <strong>Sauerland Spielgeräte GmbH</strong><br>
                        Kamp 7<br>
                        33154 Salzkotten - Niederntudorf<br>
                        <br>
                        <strong>Vertreten durch:</strong><br>
                        Rainer Gubitz, Christian Gubitz<br>
                        &nbsp;
                    </p>
                    <h2>Kontakt:</h2>
                    <p>
                        Telefon:+49 (0) 2955 7606 0<br>
                        E-Mail:info@sauerland-spielgeraete.de<br>
                        <br>
                        <strong>Registereintrag:</strong><br>
                        Eintragung im Handelsregister.<br>
                        <br>
                        <strong>Registergericht:</strong>Amtsgericht Paderborn<br>
                        <strong>Registernummer:</strong> HRB 1603
                    </p>
                    <p>&nbsp;</p>
                    <h2>Umsatzsteuer-ID:</h2>
                    <p>
                        <strong>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:</strong><br>
                        DE 126 330 602
                    </p>

                    <h2>Technische Umsetzung (Konzept und Software-Integration) sowie Hosting:</h2>
                    <p>
                        Convario GmbH & Co. KG<br>
                        Donnerschweer Straße 398<br>
                        26123 Oldenburg<br>
                        <a
                            href="https://www.convario.de/referenzen/3d-produktkonfigurator-spielplatzplanung?utm_source=sauerland-spielgeraete&utm_medium=referral&utm_campaign=partner_links&utm_content=imprint"
                            target="_blank"
                        >www.convario.de</a>
                    </p>

                    <h2>
                        <br>
                        Quellenangaben für die verwendeten Bilder und Grafiken:
                    </h2>
                    <p>
                        <a
                            target="_blank"
                            href="https://stock.adobe.com/de/"
                        >https://stock.adobe.com/de/</a><br>
                        <a
                            target="_blank"
                            href="https://www.rls.de"
                        >https://www.rls.de</a>
                    </p>
                </div>
            </article>
        </div>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/impressum',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: '',
    subTitle: '',
};
</script>

<style scoped>

</style>
